module.exports = __webpack_public_path__ + "static/media/16UNODC8.b95e4cb8.jpg";